import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const categoryCreate = (params = '') => Http.post('/partners-categories', params)
export const categoriesList = (params = '') => Http.get(`/partners-categories${serialize(params)}`)
export const categoryByID = (params = '') => Http.get(`/partners-categories/${params}`)
export const categoryUpdate = (params = '') => Http.put(`/partners-categories/${params.id}`, params)
export const categoryDestroy = (params = '') => Http.delete(`/partners-categories/${params.id}`)
